import axios from "axios";

// URL PDF selon environnement
// const urlPdf = "https://dev.api.marion-materiaux.com"; // Dev
// const urlPdf = "https://recette.api.marion-materiaux.com"; // Recette
//const urlPdf = "http://127.0.0.1:8000"; // Local (Prod simulation)
// const urlPdf = "http://test.api.marion-materiaux.com"; // Test
const urlPdf = "https://api.marion-materiaux.com";

const instance = axios.create({
  // baseURL: "https://dev.api.marion-materiaux.com/api", // Dev
//  baseURL: "https://recette.api.marion-materiaux.com/api", // Recette
  //baseURL: "http://127.0.0.1:8000/api/", // Local
  // baseURL: "http://test.api.marion-materiaux.com/api", // Test
  baseURL: "https://api.marion-materiaux.com/api", // test
});

// 🔑 Clé Google Maps
const REACT_APP_GOOGLE_MAPS_API_KEY = "AIzaSyCoMoDDmlBQA3i8TOLYp4_NBVBrSr8Dj-c";

// 🔑 Clé ORS
const ORS_API_KEY = "5b3ce3597851110001cf624808e6e5ce550a4cb29b02acaecd19dd75";

const authToken = localStorage.getItem("authToken");
const parsedUserData = JSON.parse(localStorage.getItem("userData"));

// ✅ Vérification du token
export const isTokenValid = (token) => {
  try {
    const parsedToken = JSON.parse(atob(token.split(".")[1]));
    const currentTime = Math.floor(Date.now() / 1000);
    return parsedToken.exp > currentTime;
  } catch (e) {
    return false;
  }
};

// ✅ Intercepteur d'authentification
instance.interceptors.request.use(
  (config) => {
    const authToken = localStorage.getItem("authToken");
    if (authToken) {
      config.headers.Authorization = `Bearer ${authToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ Intercepteur de réponse pour gérer le refresh automatique du token
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Si l'erreur est 401 et que ce n'est pas déjà une tentative de refresh
    if (error.response?.status === 401 && !originalRequest._retry) {
      // Si c'est l'endpoint de refresh qui échoue, déconnexion immédiate
      if (originalRequest.url === "/refresh") {
        console.warn("Token refresh failed - redirecting to login");
        localStorage.removeItem("authToken");
        localStorage.removeItem("userData");
        window.location.href = "/login";
        return Promise.reject(error);
      }

      // Si un refresh est déjà en cours, mettre la requête en file d'attente
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers.Authorization = `Bearer ${token}`;
            return instance(originalRequest);
          })
          .catch((err) => Promise.reject(err));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const authToken = localStorage.getItem("authToken");

        if (!authToken) {
          throw new Error("No token available");
        }

        // Tenter de rafraîchir le token
        const response = await instance.post("/refresh", {}, {
          headers: { Authorization: `Bearer ${authToken}` },
        });

        const newToken = response.data.token;

        // Sauvegarder le nouveau token
        localStorage.setItem("authToken", newToken);

        // Mettre à jour l'authorization header
        instance.defaults.headers.common["Authorization"] = `Bearer ${newToken}`;
        originalRequest.headers.Authorization = `Bearer ${newToken}`;

        // Traiter la file d'attente
        processQueue(null, newToken);

        // Réessayer la requête originale avec le nouveau token
        return instance(originalRequest);
      } catch (refreshError) {
        // Si le refresh échoue, déconnecter l'utilisateur
        processQueue(refreshError, null);
        localStorage.removeItem("authToken");
        localStorage.removeItem("userData");
        window.location.href = "/login";
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

export const getGoogleRouteDuration = async (origin, destination, departureTime) => {
  const timestamp = Math.floor(new Date(departureTime).getTime() / 1000);
  const originStr = `${origin.lat},${origin.lng}`;
  const destinationStr = `${destination.lat},${destination.lng}`;
  const url = `https://maps.googleapis.com/maps/api/directions/json?origin=${originStr}&destination=${destinationStr}&departure_time=${timestamp}&traffic_model=best_guess&key=${REACT_APP_GOOGLE_MAPS_API_KEY}`;

  const response = await fetch(url);
  const data = await response.json();

  if (data.status !== 'OK') {
    console.error("Erreur API Google Maps:", data.status);
    return null;
  }

  const leg = data.routes[0].legs[0];
  return Math.round((leg.duration_in_traffic || leg.duration).value / 60); // retourne minutes
};

export const getTravelTimeFromBackend = async (origin, destination, departureTime) => {
  try {
    const response = await instance.post("/calculate-duration", {
      origin: `${origin.lat},${origin.lng}`,
      destination: `${destination.lat},${destination.lng}`,
      departure_time: Math.floor(new Date(departureTime).getTime() / 1000),
    });

    if (response.data && response.data.success) {
      console.log("calculate-duration :", response.data.duration_in_minutes);
      return response.data.duration_in_minutes;
    }
    return null;
  } catch (error) {
    console.error("Erreur lors de l'appel à /calculate-duration :", error);
    return null;
  }
};



// ✅ Fonction pour appeler OpenRouteService avec des coordonnées valides
export const getORSRouteDuration = async (origin, destination) => {
  try {
    const response = await axios.post(
      "https://api.openrouteservice.org/v2/directions/driving-car",
      {
        coordinates: [
          [origin.lng, origin.lat],
          [destination.lng, destination.lat],
        ],
      },
      {
        headers: {
          Authorization: ORS_API_KEY, // clé déjà définie plus haut
          "Content-Type": "application/json",
        },
      }
    );

    const durationInSeconds = response.data.routes[0].summary.duration;
    const durationInMinutes = Math.round(durationInSeconds / 60);
    return durationInMinutes;
  } catch (error) {
    console.error("❌ Erreur ORS (OpenRouteService) :", error?.response?.data || error.message);
    return null;
  }
};

// ✅ Fonction pour calculer le prix côté backend (sécurisé)
export const calculatePriceFromBackend = async (idFournisseur, poids, estimatedTime, livraisonType) => {
  try {
    const response = await instance.post("/fo/calculate-price", {
      id_fournisseur: idFournisseur,
      poids,
      estimatedTime,
      livraisonType,
    });

    if (response.data && response.data.success) {
      console.log("💰 Prix calculé depuis le backend :", response.data.data);
      return response.data.data;
    }
    return null;
  } catch (error) {
    console.error("❌ Erreur lors du calcul de prix :", error);
    return null;
  }
};

// ✅ Exports globaux
export { urlPdf, REACT_APP_GOOGLE_MAPS_API_KEY };
export default instance;
